import React, { useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";

import NavigationMenuItem from "../../components/NavigationMenuItem";
import { authenticationService } from "../../services/AuthenticationService";
import { mstrPath } from "../../../utils/mstrBase";

function GenericLandingPage(props) {
  const { config, headerText, token } = props;
  const history = useHistory();
  const applications = useMemo(
    () => (config?.applications ? Object.values(config.applications) : []),
    [config],
  );
  const visibleApplications = useMemo(() => {
    const embeddingApplications = applications.filter(
      (app) => String(app?.url || "").toLowerCase() === "embedding",
    );

    return embeddingApplications.length > 0 ? embeddingApplications : applications;
  }, [applications]);

  useEffect(() => {
    async function validateToken() {
      if (!token) {
        history.push(mstrPath("login"));
      } else {
        try {
          await authenticationService.isSessionAlive(config, token);
        } catch (e) {
          history.push(mstrPath("login"));
        }
      }
    }

    validateToken();

    //if there is only 1 application, then redirect to it.
    if (visibleApplications.length === 1) {
      history.push(mstrPath(visibleApplications[0].url));
    }
  }, [config, history, token, visibleApplications]);

  return (
    //Landing page with all available applications for end users.
    <Box
      sx={{
        position: "relative",
        background:
          "linear-gradient(137deg, rgba(17, 81, 143, 1) 35%, rgba(25,118,210,1) 42%, rgba(16,152,226,1) 55%)",
        width: "100%",
        minHeight: "100%",
        zIndex: 98,
        flexGrow: 1,
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography gutterBottom color="text.secondary" sx={{ fontSize: 24, color: "white" }}>
        {headerText}
      </Typography>
      <Box className="landing-general-page-container">
        {visibleApplications.map((x) => (
          <NavigationMenuItem
            key={x.url}
            imageName={x.url}
            pageName={x.url}
            sx={{
              width: "300px",
              height: "300px",
              fontSize: "16px",
              textTransform: "none",
              backgroundColor: "white",
              fontFamily: "sans-serif",
              color: "rgba(17, 81, 143, 1)",
            }}
            text="MSTR"
          />
        ))}
      </Box>
    </Box>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.userDetails?.token,
    config: state.configuration,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericLandingPage);
